<template>
  <div class="admin-archived-projects-master">
    <h3>Архива</h3>
    <div v-if="!projectToDisplay" class="all-archived-projects-div">
      <p>Претрага: <input type="text" v-model="searchInfo" @keyup="getAllProjects"></p>
      <div v-for="(i,idx) in allArchived" :key="'archived'+idx">
        <button @click="getSingleProject(i.pro_id)">Опширније</button>
        <a :href="serverAdress+'print/'+i.pro_id+'?sid='+currentUserSid" target="_blank">
          <button>Штампај</button>
        </a>
        <span>{{i.udr_ime}} -- {{i.pro_ime}}</span>
        <span>{{i.pro_br_ugovora}}</span>
        <button @click="activeAreYouSure(i.pro_id)">Активирај Пројекат</button>
        <button @click="activeAreYouSureDelete(i.pro_id)">Обриши Пројекат</button>
      </div>
    </div>
    
    <display-single-project
      v-else
      :projectData="projectToDisplay"
      @getRequestsAgain="getSingleProject"
      @close="closeSingleProject">
    </display-single-project>

    <are-you-sure
      v-if="areYouSurePopup"
      :message="areYouSureMsg" 
      :resData="areYouSureData"
      @response="handleAreYouSure">
    </are-you-sure>

    <error-msg 
    v-if="errorPopup" 
    :msgText="errorMsgToShow" 
    :fatal="isItFatalError"
    @close="errorPopup=false"/>
  </div>
</template>

<script>
import DisplaySingleProject from '@/components/DisplaySingleProject.vue'
import AreYouSure from '@/components/AreYouSure.vue'
import ErrorMsg from '../components/ErrorMsg'
import extraData from '../extraData.js'
import axios from 'axios'

export default {
  components:{
    DisplaySingleProject,
    AreYouSure,
    ErrorMsg
  },
  data(){
    return {
      allArchived:[],
      searchInfo:"",
      serverAdress:"",
      projectToDisplay:null,
      areYouSurePopup: false,
      areYouSureMsg: "",
      areYouSureData:null,
      errorPopup: false,
      errorMsgToShow: "",
      isItFatalError: false
    }
  },
  computed:{
    currentUserSid(){
      return sessionStorage.getItem("sid");
    }
  },
  mounted(){
    this.serverAdress=extraData.adress;
    this.getAllProjects();
    let selectedArchived=sessionStorage.getItem("selectedArchived");
    if(selectedArchived){
      this.getSingleProject(selectedArchived);
    }
  },
  methods:{
    getAllProjects(){
      axios.get(extraData.adress+"project",{
        params:{
          sid: sessionStorage.getItem("sid"),
          completed: true,
          filter: this.searchInfo
        }
      }).then((res)=>{
        // console.log(res);
        if(res.data.res==='err'){
          if(res.data.msg==='Нисте улоговани'){
            this.isItFatalError=true;
          }
          this.errorMsgToShow=res.data.msg;
          this.errorPopup=true;
          return;
        }
        this.allArchived=res.data.data
      }).catch(()=>{
        this.isItFatalError=true;
        this.errorMsgToShow="Дошло је до проблема при конектовању на сервер";
        this.errorPopup=true;
      })
    },
    activateProject(id){
      axios.patch(extraData.adress+"project/"+id,{
        sid: sessionStorage.getItem("sid"),
        status: 'активан'
      }).then((res)=>{
        // console.log(res);
        if(res.data.res==='err'){
          if(res.data.msg==='Нисте улоговани'){
            this.isItFatalError=true;
          }
          this.errorMsgToShow=res.data.msg;
          this.errorPopup=true;
          return;
        }
        this.getAllProjects();
      }).catch(()=>{
        this.isItFatalError=true;
        this.errorMsgToShow="Дошло је до проблема при конектовању на сервер";
        this.errorPopup=true;
      })
    },
    deleteProject(id){
      axios.patch(extraData.adress+"project/"+id,{
        sid: sessionStorage.getItem("sid"),
        status: 'обрисан'
      }).then((res)=>{
        // console.log(res);
        if(res.data.res==='err'){
          if(res.data.msg==='Нисте улоговани'){
            this.isItFatalError=true;
          }
          this.errorMsgToShow=res.data.msg;
          this.errorPopup=true;
          return;
        }
        this.getAllProjects();
      }).catch(()=>{
        this.isItFatalError=true;
        this.errorMsgToShow="Дошло је до проблема при конектовању на сервер";
        this.errorPopup=true;
      })
    },
    getSingleProject(id){
      axios.get(extraData.adress+"project/"+id,{
        params:{
          sid: sessionStorage.getItem("sid")
        }
      }).then((res)=>{
        if(res.data.res==='err'){
          if(res.data.msg==='Нисте улоговани'){
            this.isItFatalError=true;
          }
          this.errorMsgToShow=res.data.msg;
          this.errorPopup=true;
          return;
        }
        // console.log(res);
        this.projectToDisplay=res.data.data;
        sessionStorage.setItem("selectedArchived", id);
      }).catch(()=>{
        this.isItFatalError=true;
        this.errorMsgToShow="Дошло је до проблема при конектовању на сервер";
        this.errorPopup=true;
      })
    },
    closeSingleProject(){
      this.projectToDisplay=null;
      sessionStorage.removeItem("selectedArchived");
    },
    activeAreYouSure(id){
      this.areYouSureData={id:id, info:'active'}
      this.areYouSureMsg="Да ли сте сигурни да желите да активирате пројекат?";
      this.areYouSurePopup=true;
    },
    activeAreYouSureDelete(id){
      this.areYouSureData={id:id, info:'delete'}
      this.areYouSureMsg="Да ли сте сигурни да желите да обришете пројекат?";
      this.areYouSurePopup=true;
    },
    closeAreYouSure(){
      this.areYouSurePopup=false;
      this.areYouSureData=null
    },
    handleAreYouSure(response, data){
      // console.log(data)
      if(response){
        if(data.info==='active'){
          this.activateProject(data.id);
        }
        if(data.info==='delete'){
          this.deleteProject(data.id);
        }
        this.closeAreYouSure();
      }
      else{
        this.closeAreYouSure();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .admin-archived-projects-master{
    background-color: rgba(0, 0, 243, 0.328);
    padding: 20px;
    width: 70%;
    margin: 20px auto;
    color: #fff;
    box-sizing: border-box;
    border-radius: 5px;
    h3{
    text-align: center;
    }
  }
  .all-archived-projects-div{
    >p{
      text-align: right;
    }
    >div{
      margin: 10px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:hover{
        background-color: rgba(0, 0, 243, 0.23);
      }
      >span:nth-of-type(2n+1){
        margin-left: 20px;
      }
      >span:nth-of-type(2n){
        margin-left: auto;
        margin-right: 20px;
      }
      button{
        @include ButtonStyling();
        margin: 0;
        font-weight: 400;
        flex-shrink: 0;
        &:last-of-type{
          margin-left: 5px;
        }
      }
    }
  }

  @media only screen and (max-width: 1000px) {
    .admin-archived-projects-master{
      width: 90%;
    }
  }

  @media only screen and (max-width: 768px) {
    .admin-archived-projects-master{
      width: 100%;
    }
    .all-archived-projects-div{
      >p{
        text-align: center;
      }
      >div{
        flex-direction: column;
        margin: 20px 0;
        padding-bottom: 20px;
        border-bottom: 1px solid lightblue;
        button{
          width: 70%;
          margin: 0;
          margin: 3px 0;
          &:last-of-type{
            margin-left: 0;
          }
        }
        a{
          width: 100%;
          margin: 0;
          text-align: center;
        }
        >span:nth-of-type(2n+1){
          margin-left: 0;
          text-align: center;
        }
      }
    }
  }
</style>